module.exports = __webpack_public_path__ + "static/media/food.583214d7.svg";